import { lowerCase, uniqueId } from 'lodash';

import { getResourceTagLabel } from 'src/data/performance';
import { isValidUrl } from 'src/lib/url';

import { PROMPT_MENU_TYPE, resourceTypeToPromptMenuType } from './menuType';

export const createBankPromptMenuItem = (brandBrief) => {
  return {
    id: brandBrief.id,
    type: PROMPT_MENU_TYPE.bank,
    label: brandBrief.label,
    title: brandBrief.title,
    subtitle: brandBrief.subtitle,
    body: brandBrief.body,
    brandVoiceName: brandBrief.brandVoiceName,
    brandBrief,
  };
};

export const createResourcePromptMenuItem = (resource) => ({
  id: resource.id,
  type: resourceTypeToPromptMenuType(resource.contentType),
  label: resource.name,
  subtitle: (resource.tags || []).map(getResourceTagLabel)?.join(', ') || '',
  resource,
});

export const createNewUrlPromptMenuItem = (value, onClick) => {
  if (isValidUrl(value)) {
    return {
      id: uniqueId('url'),
      type: PROMPT_MENU_TYPE.url,
      label: value,
      content: value,
      subtitle: 'URL',
      onClick,
    };
  }
  return null;
};

export const createUrlResourcePromptMenuItem = ({ id, name, label, tags, content }) => ({
  id,
  type: PROMPT_MENU_TYPE.url,
  label: name || label,
  content,
  subtitle: (tags || []).map(getResourceTagLabel).join(', ') || '',
});

export const filterBrandBriefItems = (value, brandBriefsMenuItems) => {
  return brandBriefsMenuItems.filter((item) => {
    if (!value) {
      return true;
    }
    return (
      lowerCase(item.label).includes(lowerCase(value)) ||
      lowerCase(item.name).includes(lowerCase(value)) ||
      lowerCase(item.body).includes(lowerCase(value))
    );
  });
};
